import { createMuiTheme } from "@material-ui/core";
import * as locale from "@material-ui/core/locale";
import * as customColors from "./customColors";

const theme = createMuiTheme(
  {
    palette: {
      primary: {
        main: customColors.blue
      },
      secondary: {
        main: customColors.orange,
        contrastText: customColors.darkBlue
      },
      text: {
        primary: customColors.darkGray,
        secondary: customColors.gray
      },
      action: {
        active: customColors.darkGray,
        disabled: customColors.gray
      }
    },
    direction: "rtl",
    overrides: {
      MuiPickersCalendarHeader: {
        root: {
          backgroundColor: customColors.darkBlue,
          color: customColors.white,
          flexDirection: "row-reverse",
          "& .MuiIconButton-root": {
            color: customColors.white,
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.1)"
            },
            "&:focus": {
              backgroundColor: "rgba(255, 255, 255, 0.1)"
            }
          },
          "& .MuiTypography-root": {
            color: customColors.white
          }
        }
      },
      MuiPickersCalendar: {
        week: {
          flexDirection: "row-reverse"
        }
      },
      MuiPickersDay: {
        daySelected: {
          backgroundColor: customColors.orange,
          color: customColors.darkBlue,
          "&:hover": {
            backgroundColor: customColors.orange
          }
        },
        current: {
          color: customColors.darkBlue,
          fontWeight: "bold"
        },
        day: {
          "&:hover": {
            backgroundColor: customColors.lightGray
          },
          "&:focus": {
            backgroundColor: customColors.lightGray,
            color: customColors.darkBlue
          }
        }
      },
      MuiPickersToolbar: {
        toolbar: {
          backgroundColor: customColors.darkBlue,
          "& .MuiPickersToolbarText-toolbarTxt": {
            color: customColors.white
          }
        }
      }
    }
  },
  locale.heIL
);

export default theme;
